import React, { useState } from 'react';

import { getConfig } from 'functions/getConfig';
import { Images } from 'assets/images';
import { contestLanguages } from 'constants/languages';
import { SearchSelect } from 'components/SearchSelect/SearchSelect';
import { Input } from 'reactstrap';
import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableHeading,
  TableData,
  TableDataLink,
  SortArrowImage,
  RankListContainer,
} from './styles';

export function RankList(props) {
  let sortedList = props.rankList.slice().sort((a, b) => {
    if (a?.eligibleStatus?.eligible === false) return 1;
    if (b?.eligibleStatus?.eligible === false) return -1;
    if (props.isTournament && a.rating === null) return 1;
    if (props.isTournament && b.rating === null) return -1;
    return props.isTournament ? b.rating - a.rating : b.maxScore - a.maxScore;
  });

  const languages = contestLanguages;

  const [rankList, setRankList] = useState(props.rankList);
  const [filteredRankList, setFilteredRankList] = useState(sortedList);
  const [listForSearch, setListForSearch] = useState(props.rankList);
  const [isAscending, setIsAscending] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(languages[0]);

  const sortRankList = () => {
    let sortedData = filteredRankList.slice().sort((a, b) => {
      return isAscending ? b.maxScore - a.maxScore : a.maxScore - b.maxScore;
    });

    setFilteredRankList(sortedData);
    setIsAscending(!isAscending);
  };

  const sortRatings = () => {
    let sortedData = filteredRankList.slice().sort((a, b) => {
      if (a?.eligibleStatus?.eligible === false) return 1;
      if (b?.eligibleStatus?.eligible === false) return -1;
      if (a.rating === null) return isAscending ? 1 : -1;
      if (b.rating === null) return isAscending ? -1 : 1;
      return isAscending ? b.rating - a.rating : a.rating - b.rating;
    });

    setFilteredRankList(sortedData);
    setIsAscending(!isAscending);
  };

  const searchByName = (event) => {
    let updatedList = [];
    updatedList = listForSearch.filter((participants) => {
      return participants.name.toLowerCase().search(event.target.value.toLowerCase()) !== -1;
    });
    if (updatedList.length) {
      setFilteredRankList(updatedList);
      setRankList(updatedList);
    } else {
      setFilteredRankList(updatedList);
      setRankList(props.rankList);
    }
  };

  const searchByLanguage = (language) => {
    let updatedList = [];
    if (language) {
      if (!language.value) {
        setSelectedLanguage(contestLanguages[0]);
        setFilteredRankList(rankList);
        setListForSearch(rankList);
      } else {
        updatedList = rankList.filter((participants) => {
          if (language.value.toLowerCase() !== contestLanguages[1].value.toLowerCase()) {
            if (participants.language.toLowerCase() === language.value.toLowerCase()) {
              return participants;
            } else return false;
          } else if (participants.language.toLowerCase() === language.value.toLowerCase()) {
            return participants;
          } else return false;
        });
        setSelectedLanguage(language);
        setFilteredRankList(updatedList);
        setListForSearch(updatedList);
      }
    }
  };

  const renderTableBody = () => {
    return filteredRankList.map((item, index) => {
      const TDLink = ({ children }) => (
        <TableData noPadding>
          <TableDataLink href={`${getConfig().REACT_URL}/cms/candidateInfo/${item.accountId}/${props.contestId}`}>
            {children}
          </TableDataLink>
        </TableData>
      );
      return (
        <TableRow isSelectedRow key={index}>
          <TDLink>{++index}</TDLink>
          <TDLink>{item.name}</TDLink>
          <TDLink>{item.email}</TDLink>
          <TDLink>{item.city ? item.city : null}</TDLink>
          <TDLink>{item.linkedIn ? item.linkedIn : null}</TDLink>
          <TDLink>{item.github ? item.github : null}</TDLink>
          <TDLink>{item.languageVersion}</TDLink>
          <TDLink>
            {props.isTournament
              ? item?.eligibleStatus?.eligible === true
                ? item.rating === null
                  ? 'Not ranked'
                  : Math.round(item.rating)
                : item?.eligibleStatus?.reason
              : item.maxScore}
          </TDLink>
          <TDLink>{item.numSubmits}</TDLink>
        </TableRow>
      );
    });
  };

  const renderTableHeading = () => {
    return (
      <TableRow isHeading>
        <TableHeading>#</TableHeading>
        <TableHeading>Name</TableHeading>
        <TableHeading>Email</TableHeading>
        <TableHeading>City</TableHeading>
        <TableHeading>LinkedIn</TableHeading>
        <TableHeading>GitHub</TableHeading>
        <TableHeading>
          <SearchSelect
            clearable={false}
            options={languages}
            onChange={searchByLanguage}
            value={selectedLanguage}
            placeholder="Language"
          />
        </TableHeading>
        <TableHeading
          onClick={() => {
            if (props.isTournament) {
              sortRatings();
            } else {
              sortRankList();
            }
          }}
          className="score"
          scope="col"
        >
          {props.isTournament ? 'Rating' : 'Score'}
          <SortArrowImage alt="arrow" src={isAscending ? Images.downArrow : Images.upArrow} />
        </TableHeading>
        <TableHeading>Submits</TableHeading>
      </TableRow>
    );
  };

  return (
    <RankListContainer>
      <Input type="text" onChange={searchByName} placeholder="Search by name..." />
      <Table>
        <TableHead>{renderTableHeading()}</TableHead>
        <TableBody>{renderTableBody()}</TableBody>
      </Table>
    </RankListContainer>
  );
}
